/**
 * @generated SignedSource<<4a3597b99db3a1f44c63af8fe11b8cce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetList_widgetList$data = {
  readonly dataSource: string;
  readonly id: string;
  readonly sections: ReadonlyArray<{
    readonly items: ReadonlyArray<{
      readonly info: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"WidgetList_listItemInfo">;
      }> | null;
      readonly rightText: string | null;
      readonly rightTextSuffix: string | null;
      readonly title: string | null;
    }>;
    readonly title: string | null;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetList_widgetList";
};
export type WidgetList_widgetList$key = {
  readonly " $data"?: WidgetList_widgetList$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetList_widgetList">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetList_widgetList",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataSource",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetListSection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "WidgetListItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rightText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rightTextSuffix",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "info",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetList_listItemInfo"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetList",
  "abstractKey": null
};
})();

(node as any).hash = "00b45890abd9da4dbfcd4d0770834c90";

export default node;
